module.exports = __webpack_public_path__ + "img/x_white.dab62cb4.svg";